import React, { useMemo } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ChartWrapper } from 'src/components';


const useStyles = makeStyles(theme => ({
  chartContainer: {
    height: '320px',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.common.gray400,
  },
  subtitle: {
    fontWeight: 500,
    textTransform: 'uppercase',
    color: theme.palette.common.gray600,
    lineHeight: 1,
  },
}));


const NvpStats = ({ allAssetsByType, currentGeoInfoTypeId }) => {
  const classes = useStyles();
  const nvpData = useMemo(() => {
    if (currentGeoInfoTypeId !== 'natural-vegetation-proportion') {
      return null;
    }

    const currentTypeAssets = allAssetsByType[currentGeoInfoTypeId] || [];
    // Filtrar assets que tengan stats con totalRichness
    const assetsWithStats = currentTypeAssets
      .filter(asset => asset.stats && typeof asset.stats.proportion === 'number')
      .sort((a, b) => a.year - b.year); // Ordenar por año

    if (assetsWithStats.length === 0) {
      return null;
    }

    const years = assetsWithStats.map(asset => asset.stats.year || asset.year);
    const nvpValues = assetsWithStats.map(asset => asset.stats.proportion);

    return {
      labels: years,
      datasets: [
        {
          label: 'Proporción de vegetación natural (%)',
          data: nvpValues,
          borderColor: '#2E7D32',
          backgroundColor: '#2E7D32',
          borderWidth: 2,
          fill: false,
          tension: 0.3,
          pointBackgroundColor: '#2E7D32',
          pointBorderColor: '#2E7D32',
          pointRadius: 4,
        },
      ],
    };
  }, [ currentGeoInfoTypeId, allAssetsByType ]);

  const nvpChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Año',
          font: {
            size: 12,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: 'Proporción de Vegetación Natural (%)',
          font: {
            size: 12,
          },
        },
        beginAtZero: false,
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
    },
  };

  // Si no hay datos, no renderizar nada
  if (!nvpData) {
    return null;
  }

  return (
    <Box mt={2}>
      <Typography className={classes.subtitle} variant="body2" component="span">
        Evolución de la Proporción de Vegetación Natural
      </Typography>
      <Box p={2} mt={0.5} className={classes.chartContainer}>
        <ChartWrapper
          type="line"
          data={nvpData}
          options={nvpChartOptions}
        />
      </Box>
    </Box>
  );
};

NvpStats.propTypes = {
  allAssetsByType: PropTypes.object.isRequired,
  currentGeoInfoTypeId: PropTypes.string,
};


export { NvpStats };
